import { render } from "./TeamBuilder.vue?vue&type=template&id=4ec84750&scoped=true"
import script from "./TeamBuilder.vue?vue&type=script&lang=js"
export * from "./TeamBuilder.vue?vue&type=script&lang=js"

import "./TeamBuilder.vue?vue&type=style&index=0&id=4ec84750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec84750"]])

export default __exports__